import { HttpResponse, authDaoFactory } from '../common'
import { errorUtil } from '../util/error-util'

const dao = authDaoFactory({
  onError: async (error: Error) => {
    errorUtil.handleHttpError(error)
  },
})

export const stravaDao = {
  getAuthUrl: async (): Promise<{ authUrl: string }> => {
    const result = await dao._http.get<HttpResponse<{ authUrl: string }>>('/strava/auth-url')
    return result.data.data[0]
  },

  getConnectionStatus: async (): Promise<{ connected: boolean }> => {
    const result = await dao._http.get<HttpResponse<{ connected: boolean }>>('/strava/status')
    return result.data.data[0]
  },

  disconnect: async (): Promise<{ disconnected: boolean }> => {
    const result = await dao._http.delete<HttpResponse<{ disconnected: boolean }>>('/strava/disconnect')
    return result.data.data[0]
  },
}
